<template>
	<div>
		<main role="main" style = "padding-top:0px">
			<div class="container-fluid right_wrapper">
				<!-- <div class="page-header">
					<div class="form-row header-style" style="margin:0px">
						<div class="form-group col-md-5" style="margin:0px">
							<div class="form-row bread-crumb-small" style = "margin:0px">
								<a href="javascript:void(0)" @click="getBackToCampaignList()" class="form-group" style="line-height:1;margin:0px">Campaign >  </a>
								<span class="form-group" style="line-height:1;margin:0px;padding-left:10px">{{campName}}</span>
							</div>
						</div>
						<div class = "col-md-7" v-if = "$store.state.keywordCurrentTab == 'sync'">
							<KeywordFilters @showPerPageChanged = "fetchKeywordList" @getKeywordForTagsList = "getKeywordForTags"/>
						</div>
					</div>
				</div> -->
				<KeywordFilters :campName="campName" @getBackToCampaignList="getBackToCampaignList" @showPerPageChanged = "fetchKeywordList" @fetchKeywordCallFromAdvFilters ="fetchKeywordCallFromAdvFilters" @getKeywordForTagsList = "getKeywordForTags"/>

				<div style="height:50px" class="pt-2" v-if="$route.params.sponsoredType!='sd'">
					<KeyWordTabBar @currentType="currentType"/>
				</div>
				<div v-if = "$store.state.keywordCurrentTab == 'sync'" style="height:99px;padding-top:10px">
					<div class = "form-group row">
						<div class = "col-md-12" >
							<KeywordActions @fetchKeywordList = "fetchKeywordList" @updateSelTag="updateSelTag" :minBidLimit='minBidLimit' :maxBidLimit='maxBidLimit' :keywordList="keywordList" @getKeywordForTagsList = "getKeywordForTags"/>
						</div>
						<div class = "col-md-12" v-if="campBudget">
							<span style="font-weight:bold;">{{'Campaign Budget: '+ campBudget + ' ($)'}}</span> 
							<p style = "color: red;margin-bottom: 0px;border: 1px solid;padding: 5px;margin-top: 5px;">Note: Individual {{$route.params.sponsoredType=='sd'?'ASIN':'keyword'}} bids can never surpass 50% of a campaign’s budget, if the input bid exceeds this amount, ML will automatically reduce it to 50% of the campaign’s budget.</p>
						</div>
					</div>
				</div>
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
				<div v-else>
					<CampaignDetailGridNew class="table_wrap extra_component" :sort='sort' @updateSortVariable="updateSortVariable" :keywordList="keywordList" :strageyLoading="strageyLoading" :minBidLimit='minBidLimit' :maxBidLimit='maxBidLimit' @showPerPageChanged="fetchKeywordList" @updateKeywordData='updateKeywordData'></CampaignDetailGridNew>
					<KeywordDetailFooter class="main_footer_wrap" @showPerPageChanged="fetchKeywordList" v-if="keywordList.length!=0"></KeywordDetailFooter>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
	import CampaignDetailGridNew from "@/components/keyword/CampaignDetailGridNew.vue";
	import KeyWordTabBar from "@/components/keyword/KeyWordTabBar.vue";
	import KeywordDetailFooter from "@/components/keyword/KeywordDetailFooter.vue"
	import KeywordActions from "@/components/keyword/KeywordActions.vue"
	import KeywordFilters from "@/components/keyword/KeywordFilters.vue"
	export default {
		name: "KeywordDetail",
		data() {
			return {
				advFilterData:{},
				sort:{
					field:'',
					order:''
				},
				strageyLoading:true,
				keywordList: [],
				productTitleList:[],
				type: "sync",
				showLoader: false,
				campName:'Campaign',
				campBudget:0,
				keywordStrategyList: [],
				keywordBidsList:[],
				tagId:null,
				minBidLimit:0,
				maxBidLimit:null
			};
		},
		components: {
			CampaignDetailGridNew,
			KeyWordTabBar,
			KeywordDetailFooter,
			KeywordActions,
			KeywordFilters
		},
		computed:{
			// keywordFilter:{
			// 	set(val){
			// 		this.$store.commit('updateKeywordsFilter',val)
			// 	},
			// 	get(){
			// 		return this.$store.state.keywordFilter
			// 	}
			// }
		},
		watch: {
			type() {
				this.tagId = null
				this.sort = {
					field:'',
					order:''
				}
				this.advFilterData = {}
			// this.keywordFilter = []
				this.$store.commit("resetKeywordTableFooterFilter");
				this.fetchKeywordList();
				this.keywordStrategyList = []
			}
		},
		mounted() {
			this.$store.state.keywordCurrentTab = "sync";
			this.fetchKeywordList();
			this.$store.state.campaign.actionSelectionControl = false;
			this.$store.state.campaign.keyWordToTagList = [];
			this.campName = atob(this.$route.params.campName);
			this.campBudget = (this.$route.params.campBudget)
		},
		methods: {
			resetKeywordList(){
				this.keywordList = []
				this.$store.state.campaign.actionSelectionControl = false
				this.$store.state.campaign.keyWordToTagList = []
				this.$store.state.keywordCurrentPageNumber = 1
			},
			fetchKeywordCallFromAdvFilters(filterData){
				this.advFilterData = JSON.parse(JSON.stringify(filterData))
				this.resetKeywordList()
				this.fetchKeywordList()
			},
			updateSortVariable(data){
				this.sort = data
				this.fetchKeywordList()
			},
			updateSelTag(val){
				this.tagId = val?val.id:''
			},
			updateKeywordData(data){
				if(data.type=='minMaxBid'){
					this.keywordList[data.index] = data.keyRow
					this.keywordList = JSON.parse(JSON.stringify(this.keywordList))
				}
				else if(data.type=='enableMl'){
					this.keywordList[data.index].manually_managed = false;
					this.keywordList[data.index].bid = data.bid;
					this.keywordList[data.index].bid_temp_value = data.bid;
					this.keywordList = JSON.parse(JSON.stringify(this.keywordList))
				}
				else if(data.type=='cpcBid'){
					this.keywordList[data.index].manually_managed = (data.bid_temp_value == '' || data.bid_temp_value == null) ? false : true;
					this.keywordList[data.index].bid_temp_value = data.bid_temp_value;
					this.keywordList[data.index].bid = data.bid_temp_value;
					this.keywordList[data.index].bid_modified_on = data.date;
					this.keywordList = JSON.parse(JSON.stringify(this.keywordList))
				}
				this.sort = {
					field:'',
					order:''
				}
			},
			// getKeywordIdArray(data){
			// 	let idArr = data.map(item=>item.ams_keyword_id)
			// 	return idArr
			// },
			getTargetIdArray(data){
				let idArr = data.map(item=>item.target_id)
				return idArr
			},
			getAsinListArray(data){
				let idArr = data.map(item=>item.asin)
				return idArr
			},
			getBackToCampaignList(){
					this.$store.state.keywordCurrentTab = "sync"
				//	this.$store.state.searchFilterString = '';
					if(this.$store.state.refreshCampaign){
						this.$store.state.refreshCampaign = false
					}
					else{
						this.$store.state.calledFromCancel = true;
					}
					this.$router.push({ path: "/campaignList" });
			},
			currentType(val) {
				this.$store.state.campaign.actionSelectionControl = false
				this.$store.state.campaign.keyWordToTagList = []
				this.$store.state.keywordCurrentPageNumber = 1
				this.$store.state.searchKeywordFilterString = ''
				this.advFilterData = {}
				this.sort = {
					field:'',
					order:''
				},
				this.type = val;
			},
			async fetchKeywordList(data) {
				var payload = {
					type: this.type,
					campaignId: this.$route.params.campaignId,
					amsCampaignId: this.$route.params.amsCampaignId,
					sponsoredType: this.$route.params.sponsoredType
				};
				if(Object.keys(this.advFilterData).length){
					payload = {...payload,...this.advFilterData}
				}
				if(data||this.tagId){
					if(data){
						payload['tag_id'] = (data=='all' ? '':data)
					}
					else{
						payload['tag_id'] = (this.tagId=='all' ? '':this.tagId)
					}
					
				}
				if(this.$store.state.searchKeywordFilterString){
					payload.q = this.$store.state.searchKeywordFilterString
				}
				let vm = this;
				this.showLoader = true;
				this.keywordList = [];
				//for sync sp/sb
				if(this.$store.state.keywordCurrentTab=='sync' && this.$route.params.sponsoredType!='sd'){
					if(this.sort && this.sort.field && this.sort.order){
						payload['sort'] = this.sort
					}
					await this.$store.dispatch("campaign/fetchSyncKeywordList", payload).then(response => {
						vm.keywordList = response;
						vm.showLoader = false
						vm.strageyLoading = true
					});
					if(vm.keywordList && vm.keywordList.length){
						 var sponsoredType = ''
						if(vm.$route.params.sponsoredType =='sp'){
							sponsoredType = 'sponsoredProducts'
						}
						else if(vm.$route.params.sponsoredType =='sb'){
							sponsoredType = 'sponsoredBrands'
						}
						let payBids = {'sponsoredType':sponsoredType,tableType:'keyword'}
						let bidPromise = this.$store.dispatch("campaign/fetchKeywordBidsList",payBids);
						this.updateKeywordListBidAndIfProdTitle('ams_keyword_id')
						this.updateKeywordListStrategy('ams_keyword_id')
						this.keywordList.splice(0,0)
						let [resBid] = await Promise.all([bidPromise]);
						// vm.keywordBidsList = (resBid.data||[]).length ? vm.getBidsById(resBid.data):[]
						vm.minBidLimit = (resBid.bidLimits||{}).min_val || 0
						vm.maxBidLimit = (resBid.bidLimits||{}).max_val 
						vm.strageyLoading = false
						
					}
				}
				// for sd type
				else if(this.$route.params.sponsoredType=='sd'){
					if(this.sort && this.sort.field && this.sort.order){
						payload['sort'] = this.sort
					}
					delete payload['campaignId']
					delete payload['type']
					payload['amsCampaignId'] = this.$route.params.amsCampaignId

					await this.$store.dispatch("campaign/fetchSDKeywordList", payload).then(response => {
						vm.keywordList = response.data;
						vm.showLoader = false
						vm.strageyLoading = true
					});

					let targetIdArray = vm.getTargetIdArray(vm.keywordList||[])
					let asinListArray = vm.getAsinListArray(vm.keywordList||[]);

					//fetching bid data using target_id and product title using asin
					if(vm.keywordList && vm.keywordList.length){
						let payBids = {'targetIdArray':targetIdArray,'asinListArray':asinListArray,'sponsoredType':'sponsoredDisplay','tableType' : 'target'}
						let bidP = this.$store.dispatch("campaign/fetchKeywordBidsList",payBids)
						let [resBid] = await Promise.all([bidP])
						vm.productTitleList = (resBid && (resBid.prodTitle || []).length) ? vm.getProdTitleByASIN(resBid.prodTitle):[]
						vm.minBidLimit = (resBid.bidLimits||{}).min_val || 0
						vm.maxBidLimit = (resBid.bidLimits||{}).max_val 
						//appending product title in keyword list on the basic of asin
						vm.updateKeywordListBidAndIfProdTitle('target_id')
						//append strategy data in keyword list
						vm.updateKeywordListStrategy('target_id')
						vm.strageyLoading=false
						vm.keywordList.splice(0,0)
					}
				}
				else{
					if(this.sort && this.sort.field && this.sort.order){
						payload['sort'] = this.sort
					}
					this.$store
						.dispatch("campaign/fetchKeywordList", payload)
						.then(response => {
							vm.keywordList = response;
							vm.showLoader = false;
						});
				}
			},
			updateKeywordListBidAndIfProdTitle(type){ 
				const vm = this;
				if(type=='ams_keyword_id'){
					this.keywordList.forEach(row=>{
						if(type && row[type]){
							let updateBid = true
							//set bid value from row if ck manually managed != true 
							// ck values are the values of fetch keyword bids list call
							row['ml_bid'] = JSON.parse(JSON.stringify(row['bid']))
							if((!row['ck_manually_managed_bid']||row['ck_manually_managed_bid'].toString() =='false')){
								updateBid = false
								row['manually_managed'] = false
							}
							else{							
								row['bid_temp_value'] = null;
								row['bid'] = null;
							}
							if(updateBid){
								row['bid'] = row['ck_bid']
								row['manually_managed'] = row['ck_manually_managed_bid']
								row['bid_temp_value'] = row['ck_bid']
							}
							row['bid_modified_on'] = row['ck_modified_on']||row['bid_modified_on']
						}
					})
				}
				else if(type=='target_id'){
					this.keywordList.forEach(row=>{
						if(type && row[type]){
							let updateBid = true
							//set bid value from row if manually managed != true 
							row['ml_bid'] = JSON.parse(JSON.stringify(row['bid']))
							if((!row['ck_manually_managed_bid']||row['ck_manually_managed_bid'].toString() =='false')){
								updateBid = false
								row['manually_managed'] = false
							}
							else{							
								row['bid_temp_value'] = null;
								row['bid'] = null;
							}
								
							if(updateBid){
								row['bid'] = row['ck_bid']
								row['manually_managed'] = row['ck_manually_managed_bid']
								row['bid_temp_value'] = row['ck_bid']
							}
							row['bid_modified_on'] = row['ck_modified_on']||row['bid_modified_on']
							if(vm.$route.params.sponsoredType =='sd' && vm.productTitleList[row['asin']]){
								row['product_title'] = vm.productTitleList[row['asin']]['product_title']
							}
						}
					})
				}
				// else{
				// 	this.keywordList.forEach(row=>{
				// 		if(type && row[type]){
				// 			let updateBid = true
				// 			//set bid value from row if manually managed != true 
				// 			row['ml_bid'] = JSON.parse(JSON.stringify(row['bid']))
				// 			if((!row['manually_managed']||row['manually_managed'].toString() =='false')){
				// 				updateBid = false
				// 				row['manually_managed'] = false
				// 			}
				// 			else{							
				// 				row['bid_temp_value'] = null;
				// 				row['bid'] = null;
				// 				row['min_bid'] = null
				// 				row['max_bid'] = null
				// 			}
				// 			if(vm.keywordBidsList[row[type]]){
				// 				if(updateBid){
				// 					row['bid'] = vm.keywordBidsList[row[type]]['bid']
				// 					row['manually_managed'] = vm.keywordBidsList[row[type]]['manually_managed']
				// 					row['bid_temp_value'] = vm.keywordBidsList[row[type]]['bid']
				// 				}
				// 				row['min_bid'] = vm.keywordBidsList[row[type]]['min_bid']
				// 				row['max_bid'] = vm.keywordBidsList[row[type]]['max_bid']
				// 				row['bid_modified_on'] = vm.keywordBidsList[row[type]]['bid_modified_on']
				// 			}
				// 			if(vm.$route.params.sponsoredType =='sd' && vm.productTitleList[row['asin']]){
				// 				row['product_title'] = vm.productTitleList[row['asin']]['product_title']
				// 			}
				// 		}
				// 	})
				// }
			},
			updateKeywordListStrategy(type){
				const vm = this;
				// this.strageyLoading=false
				if(type){
					this.keywordList.forEach(row=>{
						if(type && row[type]){
							row['strategy'] = row['rec_strategy']
							row['bid_change_reason'] = row['rec_bid_change_reason']
							row['parameter'] = row['rec_parameter']
							row['currentBid'] = row['rec_bid']
							row['currentBidDate'] = row['rec_time_created']
						}
					})
				}
			},
			updateKeywordList(type){
				const vm = this;
				this.keywordList.forEach(row=>{
					if(type && row[type]){
						let updateBid = true
						//set bid value from row if manually managed != true and min and max bid from bids list is null
						row['ml_bid'] = JSON.parse(JSON.stringify(row['bid']))
						if((!row['manually_managed']||row['manually_managed'].toString() =='false')){
							updateBid = false
							// row['min_bid'] = null
							// row['max_bid'] = null
							row['manually_managed'] = false
						}
						else{							
							row['bid_temp_value'] = null;
							row['bid'] = null;
							row['min_bid'] = null
							row['max_bid'] = null
						}
						if(vm.keywordStrategyList[row[type]]){
							row['strategy'] = vm.keywordStrategyList[row[type]]['strategy']
							row['bid_change_reason'] = vm.keywordStrategyList[row[type]]['bid_change_reason']
							row['parameter'] = vm.keywordStrategyList[row[type]]['parameter']
							row['currentBid'] = vm.keywordStrategyList[row[type]]['rec_bid']
						}
						if(vm.keywordBidsList[row[type]]){
							if(updateBid){
								row['bid'] = vm.keywordBidsList[row[type]]['bid']
								row['manually_managed'] = vm.keywordBidsList[row[type]]['manually_managed']
								row['bid_temp_value'] = vm.keywordBidsList[row[type]]['bid']
							}
							row['min_bid'] = vm.keywordBidsList[row[type]]['min_bid']
							row['max_bid'] = vm.keywordBidsList[row[type]]['max_bid']
							
						}
						if(vm.$route.params.sponsoredType =='sd' && vm.productTitleList[row['asin']]){
							row['product_title'] = vm.productTitleList[row['asin']]['product_title']
						}
						// if(row['bid']){
						// 	row['min_bid'] = null
						// 	row['max_bid'] = null
						// }
						
					}
				})
				
				this.keywordList
			},
			getStrategyById(data){
				let arr = {}
				data.forEach(item=>{
					arr[item.ams_keyword_id]=item
				})
				return arr
			},
			getStrategyByTargetId(data){
				let arr = {}
				data.forEach(item=>{
					arr[item.target_id]=item
				})
				return arr
			},
			// getBidsById(data){
			// 	let arr = {}
			// 	data.forEach(item=>{
			// 		arr[item.ams_keyword_id]=item
			// 	})
			// 	return arr
			// },
			// getBidsByTargetId(data){
			// 	let arr = {}
			// 	data.forEach(item=>{
			// 		arr[item.target_id]=item
			// 	})
			// 	return arr
			// },
			getProdTitleByASIN(data){
				let arr = {}
				data.forEach(item=>{
					arr[item.asin] = item
				})
				return arr
			},
			getKeywordForTags(data){
				
				this.fetchKeywordList(data)
				// var payload = {
				// 	type: this.type,
				// 	campaignId: this.$route.params.campaignId,
				// 	amsCampaignId: this.$route.params.amsCampaignId,
				// 	sponsoredType: this.$route.params.sponsoredType,
				// 	tag_id: data.id
				// };
				// if(this.$store.state.searchKeywordFilterString){
				// 	payload.q = this.$store.state.searchKeywordFilterString
				// }

			    // let vm = this;
			    // this.showLoader = true;
				// this.keywordList = [];
				
			    // this.$store
			    // 	.dispatch("campaign/getKeywordForTag", payload)
			    // 	.then(response => {
			    // 		vm.keywordList = response;
			    // 		vm.showLoader = false;
			   	// });
			}
		}
	};
</script>
